import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import * as MySound from '../../MySound';
import * as $ from 'jquery';

export class RF_ConfirmPick extends Component {
    static displayName = RF_ConfirmPick.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            loading: false,
            fromLocationId: "",
            fromLocationBarcode:"",
            unitsToTransferOut: 0,
            scannedProductBarcode: "",
            scannedInventory: "",
            createdDocket: 0,
            namecode: "",
            clientName: ""
        }
    }

    componentDidMount() {
        if (MyGlobal.rf_transfer) {
            var rf_transfersettings = JSON.parse(MyGlobal.rf_transfer);
            if (rf_transfersettings) {
                this.setState({
                    createdDocket: rf_transfersettings.createdDocket,
                    fromLocationId: rf_transfersettings.fromLocationId,
                    fromLocationBarcode: rf_transfersettings.fromLocationBarcode,
                    isInventoryAvailableOnTransfer: rf_transfersettings.isInventoryAvailableOnTransfer,
                    clientName: rf_transfersettings.clientName
                });
            }
        }
        if (this.props.location && this.props.location.state) {
            this.state.scannedProductBarcode = this.props.location.state.scannedProductBarcode;
            this.state.scannedInventory = this.props.location.state.scannedInventory;
        }
    }

    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }
    async putInventoryOnTransfer(scannedProductBarcode) {

        if (!scannedProductBarcode) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Please scan the Product barcode" });
            return;
        }

        if (this.state.fromLocationId <= 0) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Please scan the Transfer from Location" });
            return;
        }

        const inventory = this.state.scannedInventory;
        if (!inventory) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Inventory with barcode: " + scannedProductBarcode + " not found in the list of inventories for this location" });
            return;
        }
        this.state.clientName = inventory.clientName;
        if (!this.state.unitsToTransferOut || $.isNumeric(this.state.unitsToTransferOut) === false || this.state.unitsToTransferOut <= 0) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Please enter the units to load into the new Location" });
            return;
        }
        this.state.loading = true;

        const adhocTransferRequestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                LocationId: this.state.fromLocationId,
                Namecode: inventory.namecode,
                Docket: this.state.createdDocket,
                ProductBarcode: inventory.barcode,
                Units: this.state.unitsToTransferOut > 0 ? inventory.packSize * this.state.unitsToTransferOut : inventory.packSize,
                StaffName: MyGlobal.staffName
            })
        };
        fetch('api/Transfer/PutInventoryOnTransfer', adhocTransferRequestOptions)
            .then(async response => {
                this.state.loading = false;
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;

                // check for error response
                if (!response.ok) {
                    MySound.play(MySound.Sound.stop);
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Transfer Failed!! " + errorText });
                    return;
                }
                else {
                    if (data.success && data.Docket > 0) {
                        this.gotoAdhocTransfer(data);
                    }
                    else {
                        if (data.docket > 0 && data.responseText === "Failure to create docket line") {
                            this.gotoAdhocTransfer(data);
                        }
                        else {
                            MySound.play(MySound.Sound.stop);
                            this.setState({ alertMessage: "Transfer Failed!! " + data.responseText });
                            return;
                        }
                    }
                }
            })
            .catch(error => {
                this.state.loading = false;
                this.setState({ alertMessage: error });
                return;
            });
    }

    gotoAdhocTransfer(data) {

        this.state.alertMessage = "Moved inventory out of Location";
        this.state.namecode = data.namecode;
        this.state.createdDocket = data.docket;
        this.setRF_TransferGlobalVariables();
        MySound.play(MySound.Sound.next);
        this.goto('RF_SelectAction');
    }
    setRF_TransferGlobalVariables() {
        MyGlobal.rf_transfer = JSON.stringify({
            fromLocationId: this.state.fromLocationId,
            createdDocket: this.state.createdDocket,
            namecode: this.state.namecode,
            clientName: this.state.clientName
        });
    }
    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        const handleInputKeypress = e => {
            //it triggers by pressing the enter key
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.putInventoryOnTransfer(this.state.scannedProductBarcode);
            }
        };

        return (
            <div>
                <Container>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('RF_Pick'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><h4>Confirm Pick</h4></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><label>Confirm Qty to Pick :</label></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12} >
                            <input ref="unitInput" className="form-control" placeholder="Enter units"
                                value={this.state.unitsToTransferOut}
                                onChange={(e) => {
                                    this.setState({ unitsToTransferOut: e.target.value });
                                }}
                                readOnly={this.state.sending} onKeyPress={handleInputKeypress}></input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                          <button type="button" className="btn btn-success col-12" onClick={() => { this.putInventoryOnTransfer(this.state.scannedProductBarcode); }}  >Next</button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}><h5>Product Details</h5></Col>
                    </Row>

                    {[
                        { label: "Client", value: this.state.scannedInventory.clientName },
                        { label: "Code", value: this.state.scannedInventory.productCode },
                        { label: "Barcode", value: this.state.scannedInventory.barcode },
                        { label: "Description", value: this.state.scannedInventory.productDescription },
                        { label: "Description 2", value: this.state.scannedInventory.productDescription2 },
                        { label: "Available Units", value: this.state.scannedInventory.units },
                        { label: "Committed Units", value: this.state.scannedInventory.committedUnits },
                        { label: "Picking From", value: this.state.fromLocationBarcode },
                    ].map((item, index) => (
                        <Row className="mb-3" key={index}>
                            {/* Making the label and value closer together on larger screens */}
                            <Col xs={6} md={5} lg={5}>{item.label} :</Col>
                            <Col xs={6} md={7} lg={7}>{item.value || ""}</Col>
                        </Row>
                    ))}

                </Container>
            </div>
        );
    }
}